// extracted by mini-css-extract-plugin
module.exports = {"thumbanail-view-collapse":"ThumbnailView_thumbanail-view-collapse__NCFlq","thumbanail-view-collapse-panel":"ThumbnailView_thumbanail-view-collapse-panel__NVCPs"};